const getDefaultState = () => {
  return {
    campaign: {}
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_CAMPAIGN: (state, campaign) => {
    state.campaign = {...campaign};
  },
  RESET: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  //show snackbar
  setCampaign({ commit }, campaign) {
    commit("SET_CAMPAIGN", campaign);
  }
};

const getters = {
  campaign: state => state.campaign
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
